import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { setHeading } from "../../../accounts/account.actions";
import { DeleteArticleImageApi } from "./ArticleAction";
// import _ from 'lodash'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';


const DetailViewArticle = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { fromPath, ArticleDetails } = location.state || {};

    useEffect(() => {
        props.setHeading("View Article Details");
    });

    const tableStyle = {
        borderCollapse: "collapse",
        width: "90%",
        margin: '0 auto',
    };
    const cellStyle = {
        border: "1px solid black",
        padding: "8px",
        textAlign: "left",
    };

    const handleDelete = (image, index, articleId) => {
        // const updatedImages = ArticleDetails.images.filter((_, i) => i !== index);
        const data = { articleId: articleId, imageId: image._id }
        props.DeleteArticleImageApi(data)
        navigate("/production/Article/ViewArticle")
    };

    return (
        <>
            <div>
                {ArticleDetails ? (
                    <div>

                        <div style={{ textAlign: 'center', marginBottom: '35px' }}>
                            <Link to={fromPath}>
                                <Button variant="contained" endIcon={<ArrowBackIcon />} size="large" style={{ fontWeight: 'bold' }}> BACK TO LIST </Button>
                            </Link>
                        </div>

                        <div style={{ backgroundColor: '#aed6ae', padding: '15px', borderRadius: '25px', marginBottom: '35px' }}>
                            <Row>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Sr No: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{ArticleDetails.sequenceNumber}</span> </b></Col>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Customer Name: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{ArticleDetails.customerDetails.name}</span> </b></Col>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Brand Name: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{ArticleDetails.brandDetails.brandName}</span> </b></Col>
                            </Row>
                            <Row>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>UOM: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{ArticleDetails.uomDetails.unitName}</span> </b></Col>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Category Name: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{ArticleDetails.categoryDetails.categoryName}</span> </b></Col>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Sub Category Name: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{ArticleDetails.subCategoryDetails.subCategoryName}</span> </b></Col>
                            </Row>
                            <Row>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Article Name: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{ArticleDetails.articleName}</span> </b></Col>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Carton Size: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{ArticleDetails.cartonSize}</span> </b></Col>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Packing: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{ArticleDetails.packing}</span> </b></Col>
                            </Row>
                            <Row>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Weight: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{ArticleDetails.weight}</span> </b></Col>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Composition: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{ArticleDetails.composition}   </span> </b></Col>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>HS Code: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{ArticleDetails.hSCode}</span> </b></Col>
                            </Row>
                            <Row>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Description: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{ArticleDetails.description}</span> </b></Col>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Catlog Number: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{ArticleDetails.catlogNumber}</span> </b></Col>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Customer Catalogue Number: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{ArticleDetails.customerCatalogueNumber}</span> </b></Col>
                            </Row>
                            <Row>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Export Cost: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{ArticleDetails.exportCost}</span> </b></Col>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Currency: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{ArticleDetails.currency}</span> </b></Col>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Conversion To PKR: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{ArticleDetails.conversionToPKR}</span> </b></Col>
                            </Row>
                            <Row>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Export Price: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{ArticleDetails.exportPrice}</span> </b></Col>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Profit: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{ArticleDetails.profit}</span> </b></Col>
                                <Col style={{ marginBottom: '7px' }}><b style={{ fontSize: '17px', fontWeight: 'bold' }}>Article Total Cost: <span style={{ fontSize: '15px', fontWeight: 'lighter' }}>{ArticleDetails.articleTotalCost}</span> </b></Col>
                            </Row>
                        </div>


                        <div style={{ marginBottom: '35px' }}>
                            <Col style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '20px', marginBottom: '15px' }}> Article Variations </Col>
                            <table style={tableStyle}>
                                <thead>
                                    <tr style={{ backgroundColor: '#81abd3' }}>
                                        <th style={cellStyle}>Sr No</th>
                                        <th style={cellStyle}>Code</th>
                                        <th style={cellStyle}>Manual Code</th>
                                        <th style={cellStyle}>Colour</th>
                                        <th style={cellStyle}>Size</th>
                                        <th style={cellStyle}>Article Variation Cost</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ArticleDetails.variation.map((item, index) => (
                                        <tr key={index}>
                                            <td style={cellStyle}>{index + 1}</td>
                                            <td style={cellStyle}>{item.variationSequenceNumber}</td>
                                            <td style={cellStyle}>{item.manualVariationCode}</td>
                                            <td style={cellStyle}>{item.colourLabel}</td>
                                            <td style={cellStyle}>{item.sizeLabel}</td>
                                            <td style={cellStyle}>{item.articleVariationCost}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>


                        <div style={{ marginTop: '20px' }}>
                            {ArticleDetails.images.map((image, index) => (
                                <div
                                    key={index}
                                    style={{
                                        float: 'left',
                                        marginRight: '15px',
                                        position: 'relative',
                                        display: 'inline-block',
                                    }}
                                >
                                    {/* Image */}
                                    <a href={image.file} target="_blank" rel="noopener noreferrer">
                                        <img
                                            src={image.file}
                                            alt={`alt`}
                                            width="160px"
                                            height="160px"
                                            style={{ display: 'block', borderRadius: '8px' }}
                                        />
                                    </a>

                                    <IconButton
                                        onClick={() => handleDelete(image, index, ArticleDetails._id)}
                                        style={{
                                            position: 'absolute',
                                            top: '5px',
                                            right: '5px',
                                            backgroundColor: 'rgba(2, 2, 2, 0.8)',
                                            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                                        }}
                                        size="small"
                                        aria-label="delete"
                                    >
                                        <DeleteForeverIcon style={{ color: 'rgba(255, 255, 255, 0.8)' }} />
                                    </IconButton>
                                </div>
                            ))}
                        </div>


                    </div>
                ) : (
                    <div style={{ textAlign: "center" }}>
                        <h5> Data Not Found</h5>
                        <div style={{ textAlign: 'center', marginBottom: '35px' }}>
                            <Link to={fromPath}>
                                <Button variant="contained" endIcon={<ArrowBackIcon />} size="large" style={{ fontWeight: 'bold' }}> BACK TO LIST </Button>
                            </Link>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        setHeading: (data) => dispatch(setHeading(data)),
        DeleteArticleImageApi: (data) => dispatch(DeleteArticleImageApi(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(DetailViewArticle);